const BETA_INTEGRATION_SLUGS = new Set<string>([
  // Add integration slugs here to mark them as beta.
  'bq',
  'tesco',
  'decathlon',
  'debenhams',
  'superdrug',
  'mountainwarehouse',
  'therange',
  'freemans'
]);

export const IsBetaIntegration = (integrationSlug?: string | null): boolean => {
  if (!integrationSlug) {
    return false;
  }

  return BETA_INTEGRATION_SLUGS.has(integrationSlug.trim().toLowerCase());
};
